export default {"src":"/_next/static/media/3.19b688df.svg","height":170,"width":304,"blurWidth":0,"blurHeight":0};